// Khoi tao popup
var $signlog = $('#signlogin'),
  $lostpass = $('#lostpass'),
  $qsvpopup = $('#qsvpopup');
$signlog.modal({ show: false });
$lostpass.modal({ show: false });
$qsvpopup.modal({ show: false });


// Mo popup tu URL
function OpenPopup (url, param, name, id) {
  var method = 'post';
  if (typeof (param) == 'undefined') {
    method = 'get';
    param = {};
  }
  if (typeof (id) == 'undefined') id = 'qsvbody';

  ViewPopup(name);
  $.ajax({
    url: url,
    type: method,
    data: param,
    dataType: "html",
  }).done(function (data) {
    $('#' + id).html(data);
  }).fail(function (jqXHR, status) {
    $('#' + id).html("Request failed: " + status);
  });

  return false;
}

// Mo cua so popup
function ViewPopup (name) {
  if (typeof (name) == 'undefined') name = '';
  if (name == '') {
    $qsvpopup.find('.modal-header').hide();
    $('#qsvbody').removeClass('modal-body');
  }
  else {
    $qsvpopup.find('.modal-header').show();
    $('#qsvbody').addClass('modal-body');
  }

  $('#qsvname').html(name);
  $('#qsvbody').html('<p class="pt-3 text-center">Đang xử lý thông tin ...</p>');

  $qsvpopup.modal('show');
  $signlog.modal('hide');
  $lostpass.modal('hide');
}

function ClosePopup () {
  $signlog.modal('hide');
  $lostpass.modal('hide');
  $qsvpopup.modal('hide');
}


// Yeu cau tu van
function SendRequest (id) {
  var frm = $('#' + id),
    ok = true, err = '';

  if (frm.find('*[name=name]').val() == "") {
    frm.find('*[name=name]').focus();
    ok = false;
    err += "Bạn chưa nhập họ tên!\n";
  }

  if (frm.find('*[name=tel]').val() == "") {
    frm.find('*[name=tel]').focus();
    ok = false;
    err += "Bạn chưa nhập số điện thoại!\n";
  }

  var email = frm.find('*[name=email]').val();
  if (email != '' && !ValidEmail(email)) {
    frm.find('*[name=email]').focus();
    ok = false;
    err += "Địa chỉ email không hợp lệ!\n";
  }

  if (err != '') {
    alert(err);
    return false;
  }

  if (ok) {
    var $btn = frm.find('button'),
      $proc = $btn.next();
    $btn.hide();
    $proc.show();

    $.ajax({
      type: frm.attr('method'),
      url: frm.attr('action'),
      data: frm.serialize(),
      dataType: 'json'
    }).done(function (data) {
      var msg = "Gửi yêu cầu thất bại. Vui lòng thử lại sau!";
      if (data.success) {
        msg = "Gửi yêu cầu thành công. Cám ơn bạn!";

        // Reset form
        frm[0].reset();
        ClosePopup();
      }
      alert(msg);
    }).always(function (data) {
      //console.log("Complete: ",data);
      $btn.show();
      $proc.hide();
    }).fail(function (xhr, status) {
      console.log("Request failed: ", status);
    });
  }

  return false;
}


$('a[rel="qsvpopup"]').click(function () {
  var url = $(this).attr('href'),
    name = $(this).html(),
    title = $(this).attr('title');
  if (title != null && title != '') name = title;
  OpenPopup(url, { a: 1 }, name);
  return false;
});


// Export object Popup
window.Popup = {
  Open: OpenPopup,
  View: ViewPopup,
  Close: ClosePopup,
  Request: SendRequest
}

// Xu ly popup
$(".close-popup-send").on("click", function () {
  $(".modal-all").hide("300");
});

$(".lp-show").on("click", function () {
  $(".popup-detail").show();
});

$(".show-popupNew").on("click", function () {
  $(".autoNew").show();
});

$("#mb-show-icon-contact").on("click", function () {
  $(".box-icon-cta-group").show();
});
$(".close-group").on("click", function () {
  $(".box-icon-cta-group").hide();
});

$(".tierra-show-popup").on("click", function () {
  $(".tierra-popup-product").show();
  $(".popup-goto-facebook").show();
});

$(".close-popup").on("click", function () {
  $(".tierra-popup-product").hide();
  $(".modal-all").hide();
  $(".autoNew").hide("300");  
});

var $modal = $('#popupSend');
if ($modal.length > 0) {
  setTimeout(function () { $modal.show() }, 20000);
}


$(document).on("click", function (e) {
  if ((e.target.id === 'popupSend' || e.target.id === 'popup-detail' || e.target.id === 'popupNew1' || e.target.id === 'popupSend1') || e.target.id === 'popupCart' || e.target.id === 'popupSendTD') {
    $(".tierra-popup-product").hide("300");
    $(".modal-all").hide("300");
    $(".autoNew").hide("300");
    e.stopPropagation();
    gtag('event', 'click', { 'event_category': 'ClosePop', 'non_interaction': true });
  }
});



$(".tierra-show-popup2").on("click", function () {
    $("#popupSend2").show();     
  });
  $(".tierra-show-popup3").on("click", function () {
    $("#popupSend3").show();     
  });

  $(".tierra-show-popup4").on("click", function () {
    $("#popupSend4").show();     
  });





// WEBPACK FOOTER //
// ./src/popup.js